<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商家建档申请</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新
      </el-button>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="申请单号：">
                  <el-input
                    v-model="form.id"
                    placeholder="申请单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="城市：">
                  <el-select
                    v-model="form.city"
                    placeholder="城市"
                    @change="getMainMarketByCity"
                  >
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="市场：">
                  <el-select
                    v-model="form.market_id"
                    filterable
                    clearable
                    placeholder="市场"
                  >
                    <el-option
                      v-for="item in market"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="status" label="状态：">
                  <el-select v-model="form.status" multiple placeholder="状态">
                    <el-option
                      v-for="item in status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="主理人姓名：">
                  <el-input
                    v-model="form.supply_manager_name"
                    placeholder="主理人姓名"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机号码：">
                  <el-input
                    v-model="form.baobmobile"
                    placeholder="手机号码"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="营业类型：">
                  <el-select
                    v-model="form.business_type"
                    filterable
                    placeholder="营业类型"
                  >
                    <el-option
                      v-for="item in business_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邀请注册码：">
                  <el-input
                    v-model="form.registration_code"
                    placeholder="邀请注册码"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="商家ID">
                  <el-input
                    v-model="form.supply_id"
                    placeholder="商家ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item label="买手组">
                  <el-select 
                  v-model="form.picker_group_id" 
                  filterable
                  clearable
                  placeholder="买手组" @change="getPickerGroupMemberOption">
                    <el-option
                      v-for="item in msOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="买手">
                  <el-select v-model="form.picker_group_member_id" filterable clearable placeholder="买手">
                    <el-option
                      v-for="item in msMemberOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="对接状态">
                  <el-select v-model="form.docking_type" clearable placeholder="对接状态">
                    <el-option
                      v-for="item in dockingTypes"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="品牌名称">
                  <el-input
                    v-model="form.brand_name"
                    placeholder="品牌名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item label="申请时间：">
                  <el-date-picker
                    v-model="form.application_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="最后修改时间：">
                  <el-date-picker
                    v-model="form.updated_at"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item width="auto">
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button
                    style="background: #85ce61"
                    type="success"
                    @click="output"
                    >导出
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              align="center"
              prop="id"
              label="申请单号"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_id"
              label="商家ID"
              width="120"
            ></el-table-column>
            <el-table-column align="center" prop="" label="入驻状态" width="80">
              <template #default="scope">
                {{ scope.row.status_trans }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="" label="对接状态" width="80">
              <template #default="scope">
                {{ scope.row.docking_type_txt }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop=""
              label="个人手持执照与身份证合照"
              show-overflow-tooltip
              align="center"
              width="80"
            >
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.group_photo_trans"
                    style="max-width: 100%; max-height: 100%"
                  />
                </div>
              </template>
            </el-table-column> -->
            <el-table-column
              prop=""
              label="营业执照"
              show-overflow-tooltip
              align="center"
              width="80"
            >
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    :src="scope.row.business_license_trans"
                    style="max-width: 100%; max-height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="license" label="法人身份证" align="center">
              <template #default="{ row }">
                <img
                  v-viewer
                  :src="row.front_id_card_trans"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
                <img
                  v-viewer
                  :src="row.back_id_card_trans"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="business_type_trans"
              label="营业类型"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="公司名称"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="brand_name"
              label="品牌名称"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="city_trans"
              label="城市"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_floor"
              label="楼层"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_area"
              label="区域"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supplier_num"
              label="门牌号"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_manager_name"
              label="主理人姓名"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="baobmobile"
              label="手机号码"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="distribution_details_address"
              label="配货详细地址"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="office_address"
              label="办公详细地址"
              width="80"
            ></el-table-column>
            <el-table-column
            align="center"
            prop="picker_group_name"
            label="买手组"
            width="80"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="picker_group_member_name"
            label="买手"
            width="80"
          ></el-table-column>
            <el-table-column
              align="center"
              prop="registration_code"
              label="邀请注册码"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="application_time_trans"
              label="最近一次申请时间"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="updated_at"
              label="最后修改时间"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="reject_note"
              label="备注"
              width="80"
            ></el-table-column>
            <el-table-column
              label="操作"
              align="center"
              fixed="right"
              width="160"
            >
              <template #default="scope">
                <div>
                  <el-button
                    size="mini"
                    type="primary"
                    style="margin-bottom: 5px"
                    @click="goToDetail(scope.row)"
                    >查看
                  </el-button>
                  <el-button
                    v-if="scope.row.status === STATUS_TYPE.PENDING"
                    size="mini"
                    type="danger"
                    class="sub-bottom"
                    @click="handleReject(scope.row)"
                    >驳回
                  </el-button>
                  <el-button size="mini" @click="supplyLog(scope.row)">
                    日志
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="操作日志" :visible.sync="logVisible" width="70%">
            <div v-if="logData.length">
              <el-table :data="logData">
                <el-table-column property="event" label="事件" align="center">
                  <template #default="{ row }">
                    {{ row.type === LOGS_EVENT_TYPE.PASS ? "通过" : "" }}
                    {{ row.type === LOGS_EVENT_TYPE.REJECT ? "驳回" : "" }}
                  </template>
                </el-table-column>
                <el-table-column
                  property="content"
                  label="内容"
                  align="center"
                ></el-table-column>
                <el-table-column
                  property="admin_name"
                  label="操作人"
                  align="center"
                ></el-table-column>
                <el-table-column
                  property="updated_at"
                  label="操作时间"
                  align="center"
                ></el-table-column>
              </el-table>
            </div>
            <div v-else>暂无操作记录</div>
          </el-dialog>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.total"
            :page-size="10"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <supply-message-dialog ref="supplyMessageRef" @submit-success="fetchData" />
    <el-dialog
      title="提示"
      :visible.sync="dialogRejectVisible"
      width="30%"
      center
      @close="handleCancelReject"
    >
      <div style="margin-bottom: 20px">选择后将驳回商家申请，确认吗？</div>
      <el-form :model="rejectForm" label-width="60px">
        <el-form-item label="原因：">
          <el-input v-model="rejectForm.reject_note" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <template #footer class="dialog-footer">
        <el-button @click="dialogRejectVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmReject">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  postPage,
  postGetFindLogs,
  postReject,
} from "@/openapi/erp/supplyDocumentDraft.js";
import apiBaseURL from "@/utils/baseUrl.js";

import SupplyMessageDialog from "./components/SupplyMessageDialog.vue";
import { postGetMainMarket } from "@/openapi/erp/supply.js";
// 状态:{2:待审核;3:已入驻;4:已驳回;}
const STATUS_TYPE = {
  PENDING: "2",
  PASSED: "3",
  REJECTED: "4",
};
// 对接状态{1、已对接 2、未对接}
const DOCKING_TYPE = {
  ALREADY: "1",
  DITNOT: "2",
};
// 列表接口是否导出 0否 1是
const IS_EXPORT = {
  YES: "1",
  NO: "0",
};
// {0:未知,1:广州,2:杭州,3:深圳，4: 青岛}
const CITY_TYPE = {
  UNKNOWN: "0",
  GUANGZHOU: "1",
  HANGZHOU: "2",
  SHENZHEN: "3",
  QINGDAO: "4",
};
// 营业类型{0:未知,1:独立工作室;2:线下档口;3:工厂;4:线上店铺;}
const BUSINESS_TYPE = {
  UNKNOWN: "0",
  STUDIO: "1",
  OFFLINE: "2",
  FACTORY: "3",
  ONLINE: "4",
};
// 事件{1:通过;2:驳回;}
const LOGS_EVENT_TYPE = {
  PASS: "1",
  REJECT: "2",
};
export default {
  components: { SupplyMessageDialog },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      rejectForm: {
        id: "",
        reject_note: "",
      },
      rejectId: "",
      IS_EXPORT,
      LOGS_EVENT_TYPE,
      STATUS_TYPE,
      CITY_TYPE,
      BUSINESS_TYPE,
      dialogRejectVisible: false,
      logpages: 0,
      logcurPage: 1,
      supply_ids: [],
      showBind: false,
      logData: [],
      logVisible: false,
      resData: null,
      supply: {
        list: [],
      },
      form: {
        page: 1,
        page_size: 10,
        id: "",
        city: "",
        status: "",
        market_id: "",
        supply_manager_name: "",
        baobmobile: "",
        business_type: "",
        registration_code: "",
        updated_at: [],
        application_time: [],
      },
      supply_status: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      citys: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: CITY_TYPE.GUANGZHOU,
          label: "广州",
        },
        {
          value: CITY_TYPE.HANGZHOU,
          label: "杭州",
        },
        {
          value: CITY_TYPE.SHENZHEN,
          label: "深圳",
        },
        {
          value: CITY_TYPE.QINGDAO,
          label: "青岛",
        },
      ],
      business_type: [
        {
          value: "",
          label: "全部",
        },
        {
          value: BUSINESS_TYPE.UNKNOWN,
          label: "未知",
        },
        {
          value: BUSINESS_TYPE.STUDIO,
          label: "独立工作室",
        },
        {
          value: BUSINESS_TYPE.OFFLINE,
          label: "线下档口",
        },
        {
          value: BUSINESS_TYPE.FACTORY,
          label: "工厂",
        },
        {
          value: BUSINESS_TYPE.ONLINE,
          label: "线上店铺",
        },
      ],
      loading: false,
      tableLoading: false,
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      memberOption: [],
      defectiveGroupOption: [],
      defectiveGroupMemberOption: [],
      refundMemberOption: [],
      supply_id: 0,
      market: [],
      id: 0,
      status: [
        {
          key: STATUS_TYPE.PENDING,
          label: "待审核",
        },
        {
          key: STATUS_TYPE.PASSED,
          label: "已入驻",
        },
        {
          key: STATUS_TYPE.REJECTED,
          label: "已驳回",
        },
      ],
      dockingTypes: [
        {
          key: DOCKING_TYPE.ALREADY,
          label: "已对接",
        },
        {
          key: DOCKING_TYPE.DITNOT,
          label: "未对接",
        },
      ],
      msOptions: [],
      msMemberOptions: []
    };
  },
  mounted() {
    this.getSelectMsOptions()
  },
  computed: {
    filteredForm() {
      const filteredForm = {};
      Object.keys(this.form).forEach((key) => {
        if (
          this.form[key] !== undefined &&
          this.form[key] !== "" &&
          this.form[key] !== null
        ) {
          filteredForm[key] = this.form[key];
        }
      });
      return filteredForm;
    },
  },
  methods: {
    // 根据城市获取市场列表
    getMainMarketByCity() {
      postGetMainMarket({ city: this.form.city }).then((res) => {
        this.market = res;
        this.form.market_id = "";
      });
    },
    confirmReject() {
      postReject(this.rejectForm).then(() => {
        this.dialogRejectVisible = false;
        this.fetchData();
        this.$message.success("驳回成功");
      });
    },
    handleCancelReject() {
      this.rejectForm = this.$options.data().rejectForm;
    },
    handleReject(row) {
      this.rejectForm.id = row.id;
      this.dialogRejectVisible = true;
    },
    goToDetail(row) {
      this.$router.push(`/home/supply/supplyDetail/${row.id}`);
    },
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    output() {
      postPage({ ...this.filteredForm, is_export: IS_EXPORT.YES }).then(
        (res) => {
          window.open(apiBaseURL + res.file);
        }
      );
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      postPage(this.filteredForm).then((res) => {
        this.loading = false;
        this.resData = res;
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const temp = val;
      temp.forEach((element) => {
        this.supply_ids.push(element.supply_id);
      });
      const multipleSelection = [];
      Object.keys(val).forEach((key) => {
        multipleSelection.push(val[key].id);
      });
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },
    search() {
      this.form.page = 1;
      this.fetchData();
    },
    supplyLog(row) {
      postGetFindLogs({ id: row.id }).then((res) => {
        this.loading = false;
        this.logData = res;
        if (res.length === 0) {
          this.$message.info("暂无操作日志");
          return;
        }
        this.logVisible = true;
      });
    },

    // 获取买手组列表
    getSelectMsOptions() {
      this.$http.post("/erp/Common/selectPicker").then((res) => {
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.msOptions = res.data.data.map((item) => ({
          value: item.k,
          label: item.label,
        }));
      });
    },
    //  根据买手组id请求对应成员
    getPickerGroupMemberOption(e) {
      if(!e) {
        return
      }
      this.msMemberOptions = [];
      // this.form.picker_group_member_id = null;
      this.$http
        .post("/erp/Common/getPickerGroupMember", { pg_id: e })
        .then((res) => {
          this.msMemberOptions = res.data.data;
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.message-error {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplyapply/SupplyApplyListPro.vue